export default {"src":"/_next/static/media/mirror.8074f29b.svg","height":99,"width":98,"blurWidth":0,"blurHeight":0};